import { _t, _tf } from './translation';

export const TimeRange = (startDate, endDate, relative = false) => ({
  startDate, endDate, relative: relative || !startDate || !endDate, duration: (endDate || new Date()) - (startDate || new Date()),
});

export const getUnitMultiplier = (unit = 'hours') => {
  switch (unit) {
  case 'minutes':
    return 60 * 1000;
  case 'days':
    return 24 * 60 * 60 * 1000;
  case 'weeks':
    return 7 * 24 * 60 * 60 * 1000;
  case 'hours':
  default:
    return 60 * 60 * 1000;
  }
};

export const RecentRelativeTimeRange = ({ unit, range }) => {
  const multiplier = getUnitMultiplier(unit);
  const endDate = new Date();
  const startDate = new Date(endDate - multiplier * range);

  return TimeRange(startDate, endDate, true);
};

export const rollRelativeTimeRange = (timeRange) => {
  if (!timeRange.relative) {
    return timeRange;
  }
  const endDate = new Date();

  return {
    ...timeRange,
    endDate,
    startDate: new Date(endDate - timeRange.duration),
  };
};
export const increaseStartDuration = (timeRange, amount) => ({
  ...timeRange,
  startDate: new Date(timeRange.startDate - amount),
  duration: timeRange.duration + amount,
});
export const decreaseStartDuration = (timeRange, amount) => ({
  ...timeRange,
  startDate: new Date(timeRange.startDate - 0 + amount),
  duration: timeRange.duration - amount,
});
export const setStartDuration = (timeRange, amount) => ({
  ...timeRange,
  startDate: new Date(timeRange.endDate - amount),
  duration: amount,
});
export const moveTowardsPast = (timeRange, amount) => ({
  ...timeRange,
  startDate: new Date(timeRange.startDate - amount),
  endDate: new Date(timeRange.endDate - amount),
  relative: false,
});

export const moveTowardsFuture = (timeRange, amount) => ({
  ...timeRange,
  startDate: new Date(timeRange.startDate - 0 + amount),
  endDate: new Date(timeRange.endDate - 0 + amount),
  relative: false,
});

const units = [
  { name: 'Milliseconds', multiplier: 1, max: 1000 },
  { name: 'Seconds', multiplier: 1000, max: 59 },
  { name: 'Minutes', multiplier: 60 * 1000, max: 59 },
  { name: 'Hours', multiplier: 60 * 60 * 1000, max: 23 },
  { name: 'Days', multiplier: 24 * 60 * 60 * 1000, max: 6 },
  { name: 'Weeks', multiplier: 7 * 24 * 60 * 60 * 1000, max: 4 },
  { name: 'Months', multiplier: 30 * 24 * 60 * 60 * 1000, max: 11 },
  { name: 'Years', multiplier: 365.25 * 24 * 60 * 60 * 1000 },
];

const formatDurationWithUnit = (duration, unit) => {
  const amount = duration / unit.multiplier;
  const unitString = (amount === 1 ? unit.name.slice(0, unit.name.length - 1) : unit.name).toLowerCase();
  const roundedString = amount.toFixed(2);

  return _tf('Last {amount} {unit}', { amount: roundedString, unit: _t(unitString) });
};

const getAppropriateUnit = (duration) => {
  let unit;
  let i = 0;
  let amount;
  do {
    unit = units[i];
    amount = duration / unit.multiplier;
    i++;
  } while (amount > unit.max && i < units.length);

  return unit;
};

export const formatDuration = (duration) => {
  const unit = getAppropriateUnit(duration);

  return formatDurationWithUnit(duration, unit);
};

export const formatTimeRange = (timeRange) => {
  if (!timeRange.relative) {
    return `${timeRange.startDate.toLocaleDateString()} - ${timeRange.endDate.toLocaleDateString()}`;
  }

  return formatDuration(timeRange.duration);
};

export const getQueryTimeWindow = (timeRange) => {
  if (timeRange.relative) {
    const timeEnd = timeRange.endDate || new Date();
    return {
      start: new Date(timeEnd.getTime() - timeRange.duration),
      end: timeEnd,
      duration: timeRange.duration,
    };
  }
  return {
    start: timeRange.startDate,
    end: timeRange.endDate,
    duration: timeRange.duration,
  };
};

export const getLocaleDateTime = ({
  date, year = 'numeric', month = 'numeric', day = 'numeric', hour = '2-digit', minute = '2-digit',
}) => (
  new Date(date).toLocaleTimeString([], {
    year,
    month,
    day,
    hour,
    minute,
  })
);

export const getLocaleTime = ({
  date, hour = '2-digit', minute = '2-digit',
}) => (
  new Date(date).toLocaleTimeString([], {
    hour,
    minute,
  })
);
